module.exports = "<p>\r\n  allocation works!\r\n</p>\r\n"